import firebase from 'firebase';

// Initialize Firebase.
const config = {
    apiKey: 'AIzaSyB5mGJOYgtnr79vHCVNCbk7VofGVOG_7ko',
    authDomain: 'lumdash.firebaseapp.com',
    databaseURL: 'https://lumdash.firebaseio.com',
    projectId: 'lumdash',
    storageBucket: 'lumdash.appspot.com',
    messagingSenderId: '761141038593',
    clientId:
        '761141038593-4ffpdk6ci43vdt18d41np2uaej4nq2f3.apps.googleusercontent.com',
    discoveryDocs: [
        'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
    ],
};

const firebaseApp = firebase.initializeApp(config);
const auth = firebase.auth();
const googleAuth = new firebase.auth.GoogleAuthProvider();
googleAuth.addScope('profile');
googleAuth.addScope('https://www.googleapis.com/auth/calendar.readonly');
googleAuth.addScope('https://www.googleapis.com/auth/calendar.events.readonly');
googleAuth.addScope('https://www.googleapis.com/auth/analytics.readonly');
export { auth, firebaseApp, googleAuth };



// WEBPACK FOOTER //
// ./src/firebase.js